import { TRIGGER_RESPONSE_CODES } from "constants/flowDesigner";
const responseCodes = [
  {
    label: "200",
    subLabel: "Ok - Request has succeeded",
    value: "200"
  },
  {
    label: "201",
    subLabel: "Created - Request has been fulfilled",
    value: "201"
  },
  {
    label: "204",
    subLabel: "No Content - Request processed, no content returned",
    value: "204"
  },
  {
    label: "301",
    subLabel: "Moved Permanently - Resource has been moved",
    value: "301"
  },
  {
    label: "302",
    subLabel: "Found - Resource moved temporarily",
    value: "302"
  },
  {
    label: "304",
    subLabel: "Not Modified - Resource has not been modified",
    value: "304"
  },
  {
    label: "400",
    subLabel: "Bad Request - Request could not be understood",
    value: "400"
  },
  {
    label: "401",
    subLabel: "Unauthorized - Authentication is required",
    value: "401"
  },
  {
    label: "403",
    subLabel: "Forbidden - Server understood, but refused to fulfill",
    value: "403"
  },
  {
    label: "404",
    subLabel: "Not Found - Server has not found a match",
    value: "404"
  },
  {
    label: "Custom",
    subLabel: "Write your own HTTP code",
    value: TRIGGER_RESPONSE_CODES.CUSTOM
  }
];

export const form = {
  formId: "http-form",
  formField: {
    endpointUrl: {
      name: "endpointUrl",
      label: "Endpoint URL",
      type: "readonlyEndpoint",
      placeholder: "",
      errorMsg: ""
    },
    method: {
      name: "method",
      label: "HTTP Method",
      type: "multiSelect",
      placeholder: "",
      errorMsg: "Method is required.",
      options: [
        {
          value: "GET",
          label: "GET"
        },
        {
          value: "POST",
          label: "POST"
        },
        {
          value: "PUT",
          label: "PUT"
        },
        {
          value: "PATCH",
          label: "PATCH"
        },
        {
          value: "DELETE",
          label: "DELETE"
        },
        {
          value: "OPTIONS",
          label: "OPTIONS"
        }
      ]
    },
    credentials: {
      name: "credentials",
      label: "Credentials",
      type: "credentials",
      placeholder: "",
      errorMsg: "Credentials are required.",
      options: []
    },
    credentialType: {
      name: "credentialType",
      label: "Credentials Type",
      type: "select",
      placeholder: "",
      errorMsg: "Credentials Type is required.",
      options: []
    },
    credential: {
      name: "credential",
      type: "select",
      label: "Select Credential",
      errorMsg: "Credential is required.",
      isDisabled: false
    },
    credentialName: {
      name: "credentialName",
      label: "Name",
      type: "text",
      placeholder: "",
      errorMsg: "Name is required."
    },
    username: {
      name: "username",
      label: "Username",
      type: "text",
      placeholder: "",
      errorMsg: "Username is required."
    },
    password: {
      name: "password",
      label: "Password",
      type: "password",
      placeholder: "",
      errorMsg: "Password is required."
    },
    token: {
      name: "token",
      label: "Token",
      type: "token"
    },
    required: {
      name: "required",
      label: "Requires Credential",
      type: "boolean",
      placeholder: "",
      errorMsg: ""
    },
    respond: {
      name: "respond",
      label: "Respond",
      type: "selectWithDetails",
      placeholder: "",
      errorMsg: "",
      options: [
        {
          label: "Immediately",
          subLabel: "As soon as this node executes",
          value: "immediately"
        },
        {
          label: "When Last Node Finishes",
          subLabel: "Returns data of the last-executed node",
          value: "last_node_finishes"
        },
        {
          label: "After Node Finishes",
          subLabel: "Returns the data after the specific node is executed",
          value: "after_specific_node"
        },
        {
          label: "Using Code Node",
          subLabel: "Response defined in the specified code node",
          value: "use_code_node"
        },
        {
          label: "Inline",
          subLabel: "Code or Respond nodes define when to send response",
          value: "inline_code"
        }
        // {
        //   label: "Using Code Expression",
        //   subLabel: "Response defined in the specified code expression",
        //   value: "use_code_expression",
        // },
      ]
    },
    // requestHeaders: {
    //   name: "requestHeaders",
    //   label: "Request Headers",
    //   type: "keyValue",
    //   placeholder: "",
    //   errorMsg: "",
    // },
    additionalOptions: {
      name: "additionalOptions",
      label: "Additional Options",
      type: "select",
      placeholder: "",
      errorMsg: ""
    },
    responseCode: {
      name: "responseCode",
      label: "Response Code",
      type: "selectWithDetails",
      placeholder: "",
      errorMsg: "",
      options: responseCodes
    },
    customResponseCode: {
      name: "customResponseCode",
      label: "Custom Code",
      type: "text",
      placeholder: "",
      errorMsg: "Custom Code is required."
    },
    responseHeaders: {
      name: "responseHeaders",
      label: "Response Headers",
      type: "keyValue",
      placeholder: "",
      errorMsg: ""
    },
    payloadContentType: {
      name: "payloadContentType",
      label: "Response Body Type",
      type: "select",
      options: [
        { value: "formData", label: "Form Data" },
        { value: "json", label: "JSON" },
        { value: "xml", label: "XML" },
        { value: "text", label: "Text" },
        { value: "html", label: "HTML" },
        { value: "css", label: "CSS" },
        { value: "javascript", label: "Javascript" }
      ],
      placeholder: ""
    },
    payload: {
      name: "payload",
      label: "Payload",
      type: "json",
      placeholder: "",
      errorMsg: ""
    },
    formData: {
      name: "formData",
      label: "Form Data",
      type: "keyValue",
      placeholder: "",
      errorMsg: ""
    },
    node: {
      name: "node",
      label: "Node",
      type: "selectWithDetails",
      placeholder: "",
      errorMsg: "",
      options: []
    },
    allowedOrigins: {
      name: "allowedOrigins",
      label: "Allowed Origins (CORS)",
      type: "text",
      placeholder: "",
      errorMsg: ""
    },
    notes: {
      name: "notes",
      label: "Notes",
      type: "text",
      placeholder: "",
      errorMsg: ""
    },
    returnConsoleLog: {
      name: "returnConsoleLog",
      label: "Return Console Log",
      type: "boolean",
      placeholder: "",
      errorMsg: ""
    },
    topics: {
      name: "topics",
      label: "Topics",
      type: "tag",
      placeholder: "Enter topics",
      errorMsg: ""
    }
  }
};
